import { Coffee, Moon, Sun } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { ThemePreference } from "@recobra/schemas/user";
import { Field, FieldContent, FieldLabel, FieldSet } from "@recobra/ui/field";
import { RadioGroup, RadioGroupItem } from "@recobra/ui/radio-group";

import { DEFAULT_THEME, useUserPreferences } from "../lib";

/** Saves the theme the moment it is picked, independently of the profile form's submit. */
export const ThemePreferenceField: FC = () => {
  const { preferences, updatePreferences } = useUserPreferences();

  return (
    <FieldSet>
      <RadioGroup
        value={preferences.theme ?? DEFAULT_THEME}
        onValueChange={(value) => {
          const option = themeOptions.find((candidate) => candidate.id === value);
          if (option) updatePreferences({ theme: option.id });
        }}
      >
        {themeOptions.map(({ id, labelKey, icon: Icon }) => (
          <FieldLabel key={id} htmlFor={`profile-theme-${id}`}>
            <Field orientation="horizontal">
              <Icon className="size-4 shrink-0 text-muted-foreground" />
              <FieldContent>{labelKey()}</FieldContent>
              <RadioGroupItem value={id} id={`profile-theme-${id}`} />
            </Field>
          </FieldLabel>
        ))}
      </RadioGroup>
    </FieldSet>
  );
};

const themeOptions: Array<{
  id: ThemePreference;
  labelKey: () => string;
  icon: FC<{ className?: string }>;
}> = [
  {
    id: "light",
    labelKey: m.profile_theme_light,
    icon: Sun,
  },
  {
    id: "dark",
    labelKey: m.profile_theme_dark,
    icon: Moon,
  },
  {
    id: "soft",
    labelKey: m.profile_theme_soft,
    icon: Coffee,
  },
];
